import { usePathname } from 'lib/i18n/routing'
import GlobalHeadTags, { type Props } from './component'

export default function PagesRouterGlobalHeadTags(
	props: Omit<Props, 'pathname'>
) {
	const pathname = usePathname()
	return <GlobalHeadTags {...props} pathname={pathname} />
}
